import script from "./filter-criteria.vue?vue&type=script&setup=true&lang=js"
export * from "./filter-criteria.vue?vue&type=script&setup=true&lang=js"

import "./filter-criteria.vue?vue&type=style&index=0&id=2a7075ed&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7075ed"]])

export default __exports__